import React from 'react';
import PropTypes from 'prop-types';

import './Links.css';

function Links({ daten, divHeight, viewportWidth }) {
  const linkDaten = daten[0 % daten.length].weblinks;

  return (
    <div
      className={viewportWidth > 768 ? 'links' : 'links-mobil'}
      style={viewportWidth > 768 ? { height: divHeight } : null}
    >
      <ul>
        {
      linkDaten.map((data) => (
        <li className="link-liste">
          <a target="_blank" rel="noopener noreferrer" href={data}>{data}</a>
        </li>
      ))
      }
      </ul>
    </div>
  );
}

export default Links;

Links.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  daten: PropTypes.object.isRequired, // hier kann man noch einen spezifischeren Datentyp angeben
  divHeight: PropTypes.number.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
